import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout, selectTokenExpire, selectIsAuthenticated } from '../components/User/services/authSlice';

// eslint-disable-next-line import/prefer-default-export
export const useAutoLogout = () => {
  const dispatch = useDispatch();
  const expiresAt = useSelector(selectTokenExpire);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    if (!expiresAt || !isAuthenticated) return;

    const utcDate = new Date(expiresAt);
    const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);
    const timeout = localDate.getTime() - Date.now();

    let timer = null;
    if (timeout <= 0) {
      dispatch(logout());
    } else {
      timer = setTimeout(() => {
        dispatch(logout());
      }, timeout);
    }

    // eslint-disable-next-line consistent-return
    return () => clearTimeout(timer);
  }, [expiresAt, isAuthenticated]);
};
